// ProtectedRoute.js (ponovitev)
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../AuthContext';
import FullPageSpinner from '../LoadingScreen';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useContext(AuthContext);
    const location = useLocation();

    if (loading) {
        return <FullPageSpinner />;
    }

    if (!user) {
        // Tu posredujemo "state: { from: location }", da vemo, kam se vrniti
        return <Navigate to="/prijava" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;